import { RegisterOptions } from "react-hook-form";

const Validators: Record<string, Partial<RegisterOptions>> = {
  email: {
    required: true,
    validate: {
      // eslint-disable-next-line no-control-regex
      isValidCharset: (value) => /^[\u0000-\u00ff]+$/.test(value) || "Illegal characters are not allowed",
      isValidFormat: (value) => /^.+@.+\..+$/.test(value),
    },
  },
};

export default Validators;
